import { useEffect, useState } from "react";
import { getImageUrl } from "../context/imageContext";
import { primeMediaUrlsFromEntities } from "../functions/apiFunctions/mediaUrls";
import { transformWordpressKabelkrantCategory, transformWordpressPostToPostSlidePreprocessed } from "../functions/transformFunctions";
import { PostSlidePreprocessed } from "../types/transformedType";
import { WordpressKabelkrantCategory } from "../types/wordpressTypes/wordpresskabelkrantCategory";
import { RequiredWordpressPost, WordpressPost } from "../types/wordpressTypes/wordpressPost";

export function useProcessWordpressPostData(wordPressPosts: RequiredWordpressPost[], wordpressKabelkrantCategories: WordpressKabelkrantCategory[]) {
  const [posts, setPosts] = useState<PostSlidePreprocessed[]>([]);

  async function processPosts() {
    primeMediaUrlsFromEntities(wordpressKabelkrantCategories);
    primeMediaUrlsFromEntities(wordPressPosts);
    // Format all the categories
    const kabelkrantCategories = await Promise.all(wordpressKabelkrantCategories.map((category) => transformWordpressKabelkrantCategory(category, getImageUrl)));
    // Create an object of the categories
    //const categoriesObject = Object.fromEntries(catergories);
    const correctPosts = wordPressPosts.filter((post) => post != null) as unknown as WordpressPost[];
    const transformedPosts = await Promise.all(correctPosts.map((post) => transformWordpressPostToPostSlidePreprocessed(post, kabelkrantCategories, getImageUrl)));
    // Update all properties
    setPosts(transformedPosts);
  }

  useEffect(() => {
    processPosts();
  }, [wordPressPosts, wordpressKabelkrantCategories]);

  return { processPosts, posts };
}
